import { useEffect, useState } from "react";
import { getKbs } from "../services/getKbs";
import { useFullDocument } from "./useFullDocument";

export function useKbs(documentId: string) {
  const [kbs, setKbs] = useState<Array<{ id: string }>>([]);
  const fullDocument = useFullDocument(documentId);
  const [loading, setLoading] = useState(true);

  async function asyncCall() {
    if (
      !fullDocument.document ||
      Object.keys(fullDocument.document).length === 0
    ) {
      return;
    }
    setLoading(true);

    const _kbs = await getKbs();
    // console.log(fullDocument.document);

    const selected = _kbs.filter((kb: any) =>
      fullDocument.document.knowledge_base_item_ids.includes(kb.id),
    );
    const notSelected = _kbs.filter(
      (kb: any) =>
        !fullDocument.document.knowledge_base_item_ids.includes(kb.id),
    );
    setKbs([...selected, ...notSelected]);
    setLoading(false);
  }

  useEffect(() => {
    if (fullDocument) {
      asyncCall();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fullDocument.loading]);

  return { kbs, loading, refetch: asyncCall };
}
